export interface BatchSchoolStatisticsGetPredefinedSettingRequest {
  selectId: string
}

export function BatchSchoolStatisticsGetPredefinedSettingRequestToJSON(
  value: BatchSchoolStatisticsGetPredefinedSettingRequest
): any {
  return {
    select_id: value.selectId
  }
}
